import { useParams, Link } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { useEmpresa } from '@/api/queries/empresa';
import { Skeleton } from '@/components/ui/skeleton';
import { EmpresaProfileHeader } from '@/components/EmpresaProfileHeader';
import { TabVisaoGeral } from '@/components/tabs/TabVisaoGeral';
import { TabPreAnalise } from '@/components/tabs/TabPreAnalise';
import { TabContatos } from '@/components/tabs/TabContatos';
import { TabEnderecos } from '@/components/tabs/TabEnderecos';
import { TabServicos } from '@/components/tabs/TabServicos';
import { TabOportunidades } from '@/components/tabs/TabOportunidades';
import { TabTimeline } from '@/components/tabs/TabTimeline';
import { TabCadencia } from '@/components/tabs/TabCadencia';
import { TabTarefas } from '@/components/tabs/TabTarefas';

export function EmpresaProfilePage() {
  const { id = '' } = useParams<{ id: string }>();
  const { data: empresa, isLoading, error } = useEmpresa(id);

  if (error) return <p className="text-destructive">Erro carregando empresa.</p>;
  if (isLoading || !empresa) return <Skeleton className="h-96 w-full" />;

  return (
    <div className="space-y-6">
      <div className="text-sm text-muted-foreground">
        <Link to="/empresas" className="hover:underline">
          ← Empresas
        </Link>
      </div>

      <EmpresaProfileHeader e={empresa} />

      <Tabs defaultValue="visao">
        <TabsList>
          <TabsTrigger value="visao">Visão Geral</TabsTrigger>
          <TabsTrigger value="pre">Pré-análise</TabsTrigger>
          <TabsTrigger value="contatos">Contatos</TabsTrigger>
          <TabsTrigger value="enderecos">Endereços</TabsTrigger>
          <TabsTrigger value="servicos">Serviços</TabsTrigger>
          <TabsTrigger value="oportunidades">Oportunidades</TabsTrigger>
          <TabsTrigger value="tarefas">Tarefas</TabsTrigger>
          <TabsTrigger value="timeline">Timeline</TabsTrigger>
          <TabsTrigger value="cadencia">Cadência</TabsTrigger>
        </TabsList>

        <TabsContent value="visao">
          <TabVisaoGeral empresaId={id} />
        </TabsContent>
        <TabsContent value="pre">
          <TabPreAnalise empresaId={id} />
        </TabsContent>
        <TabsContent value="contatos">
          <TabContatos empresaId={id} />
        </TabsContent>
        <TabsContent value="enderecos">
          <TabEnderecos empresaId={id} />
        </TabsContent>
        <TabsContent value="servicos">
          <TabServicos empresaId={id} />
        </TabsContent>
        <TabsContent value="oportunidades">
          <TabOportunidades empresaId={id} />
        </TabsContent>
        <TabsContent value="tarefas">
          <TabTarefas empresaId={id} />
        </TabsContent>
        <TabsContent value="timeline">
          <TabTimeline empresaId={id} />
        </TabsContent>
        <TabsContent value="cadencia">
          <TabCadencia empresaId={id} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
